<template>
	<div class="satellite">
		<span class="satellite-title" data-toggle="modal" data-target="#modal-satellite">Suscríbete</span>
	</div>
</template>

<script>
var scroll_pos = 0;
	
	ready: {
			$(window).scroll(function(){
				/*scroll_pos = $(this).scrollTop();
				if(scroll_pos > 100){
					$('.satellite-title').fadeIn();
				}
				else {
					$('.satellite-title').fadeOut();
				}*/
				$(".satellite-title").stop().animate({"marginTop": ($(window).scrollTop()) + "px"}, "20000" );
			});
		}
</script>


// WEBPACK FOOTER //
// Satellite.vue?1a37717f